import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputAdornment,
  OutlinedInput,
  Switch,
  SwitchProps,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  CheckboxStyle,
  inputStyles,
  SecInputStyles,
} from "../../CreateNewPromodeod/View/CreatePromoCode";
import { PromoDropdown } from "../../CreateNewPromodeod/Components/PromoDropdown";
import { DurationDropdownItems, PromotionDropdownItems } from "../../../Helper";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Dayjs } from "dayjs";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import Stack from "@mui/material/Stack";
import "../../Views/promoCode.css";
import { useNavigate } from "react-router-dom";

export const UpdatePromoCode = () => {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const navigate = useNavigate();
  const IOSSwitch = styled((props: SwitchProps) => (
    <Switch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: "red", // Background when checked
          opacity: 1,
          border: 0,
          ...theme.applyStyles?.("dark", {
            backgroundColor: "#D32F2F",
          }),
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.grey[100],
        ...theme.applyStyles?.("dark", {
          color: theme.palette.grey[600],
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.7,
        ...theme.applyStyles?.("dark", {
          opacity: 0.3,
        }),
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 22,
      height: 22,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: "green", // Background when unchecked
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
      ...theme.applyStyles?.("dark", {
        backgroundColor: "#388E3C",
      }),
    },
  }));
  const [promoFormInputs, setPromoFormInputs] = useState({
    codeId: "",
    codeName: "",
    description: "",
    promotion: {
      type: "",
      discount: 0,
      amount: 0,
    },
    duration: {
      type: "",
      months: 0,
    },
    expirationDate: null as Dayjs | null,
    limitationTimes: 0,
  });
  const [promoFormErrors, setPromoFormErrors] = useState({
    codeId: {
      isError: false,
      errorMsg: "",
    },
    codeName: {
      isError: false,
      errorMsg: "",
    },
    promotion: {
      isError: false,
      errorMsg: "",
    },
  });

  const handleLimitationTimesInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const numericValue = event.target.value.replace(/\D/g, "");

    setPromoFormInputs((prevState) => ({
      ...prevState,
      limitationTimes: numericValue ? Number(numericValue) : 0,
    }));
  };

  const handlePromotionInputChange = (item: string) => {
    setPromoFormInputs((prevState) => ({
      ...prevState,
      promotion: {
        ...prevState.promotion,
        type: item,
      },
    }));
  };

  const handleDateChange = (newDate: Dayjs | null) => {
    setPromoFormInputs((prevState) => ({
      ...prevState,
      expirationDate: newDate,
    }));
  };

  const handleCodeIdInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPromoFormInputs((prevState) => ({
      ...prevState,
      codeId: event.target.value,
    }));
  };

  const handleCancelSaveChanges = () => {
    navigate("/admin/manage-coupons");
  };
  return (
    <Box className="promoCode-body-container">
      <Box className="promoCode-body-header justify-content-between">
        <Typography className="page-header-main-title">
          Edit promo code
        </Typography>
        <Box className="activation-box">
          <Typography className="active-text">Active</Typography>
          <Box sx={{ marginRight: "0" }}>
            <FormControlLabel
              control={<IOSSwitch sx={{ m: 1 }} />}
              label=""
              sx={{ margin: 0 }}
            />
          </Box>
          <Typography className="expired-text">Expired</Typography>
        </Box>
      </Box>
      <Box className="promoCode-body-content">
        <Box className="promoCode-body-left-side" sx={{ marginBottom: "0" }}>
          <Box className="codeId box">
            <Box className="box-titles">
              <Typography className="box-title">Code*</Typography>
              <Typography className="box-description">
                Select a unique code, that only contains alphanumeric characters
              </Typography>
            </Box>
            <Box className="inputs-box">
              <TextField
                maxRows={1}
                sx={{ ...inputStyles, width: "55%" }}
                value={promoFormInputs.codeId}
                onChange={handleCodeIdInputChange}
                error={promoFormErrors.codeId.isError}
                helperText={promoFormErrors.codeId.errorMsg}
              />
            </Box>
          </Box>
          <Box className="promotion box">
            <Box className="box-title">
              <Typography className="box-title">Promotion Type *</Typography>
              <Typography className="box-description">
                Select type of promotion.{" "}
              </Typography>
              <Box className="inputs-box">
                <PromoDropdown
                  width="55%"
                  handleSelect={handlePromotionInputChange}
                  selectedItem={promoFormInputs.promotion.type}
                  dropdownItems={PromotionDropdownItems}
                  defaultRenderValue="Select value"
                />
                {promoFormInputs.promotion.type === "Percentage Off" ||
                promoFormInputs.promotion.type === "Flat Amount Off" ||
                promoFormInputs.promotion.type === "Limited Time" ? (
                  <Box
                    sx={{
                      width: "40%",
                      position: "absolute",
                      top: "-25px",
                      right: "0",
                    }}
                  >
                    <Typography
                      className="box-title"
                      sx={{ paddingBottom: "4px" }}
                    >
                      Discount *
                    </Typography>
                    <FormControl sx={{ width: "100%" }}>
                      <OutlinedInput
                        endAdornment={
                          <InputAdornment position="end">
                            <Typography className="secInputLabel">
                              Off
                            </Typography>
                          </InputAdornment>
                        }
                        aria-describedby="outlined-weight-helper-text"
                        inputProps={{
                          "aria-label": "weight",
                          inputMode: "numeric",
                          pattern: "[0-9]*",
                        }}
                        sx={{ ...SecInputStyles }}
                      />
                    </FormControl>
                  </Box>
                ) : null}
              </Box>
            </Box>
          </Box>
          <Box className="limit box">
            <Box className="box-title">
              <Typography className="box-title">Usage limit</Typography>
              <Typography className="box-description">
                Set limited number of use
              </Typography>
            </Box>
            <Box className="inputs-box">
              <OutlinedInput
                value={promoFormInputs.limitationTimes}
                onChange={handleLimitationTimesInputChange}
                endAdornment={
                  <InputAdornment position="end">
                    <Typography className="secInputLabel">Times</Typography>
                  </InputAdornment>
                }
                aria-describedby="outlined-weight-helper-text"
                inputProps={{
                  "aria-label": "weight",
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                }}
                sx={{ ...SecInputStyles, width: "55%" }}
              />
            </Box>
            <Box className="select-option">
              <Checkbox {...label} sx={CheckboxStyle} name="singleUsePerUser" />
              <Typography className="update-select-option-text">
                Apply unlimited usage
              </Typography>
            </Box>
          </Box>
          <Box className="expiration box">
            <Box className="box-title">
              <Typography className="box-title">Validity Date</Typography>
            </Box>
            <Box className="inputs-box">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["SingleInputDateRangeField"]}
                  sx={{ width: "55%" }}
                >
                  <DatePicker
                    value={promoFormInputs.expirationDate}
                    onChange={handleDateChange}
                    sx={{
                      ...SecInputStyles,
                      width: "100%",
                      "& .MuiInputAdornment-root .MuiSvgIcon-root": {
                        color: "var(--Main_icons_color)",
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
          </Box>
          <Box className="RegisterOrSignIn ">
            <Box
              className="buttons"
              sx={{ justifyContent: "flex-start !important" }}
            >
              <button
                className="signInBtn cancel-promoCode-changes"
                onClick={handleCancelSaveChanges}
              >
                <span>Cancel</span>
              </button>

              <button className="registerBtn save-promoCode-changes">
                <span>Save changes</span>
              </button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
